export default __webpack_public_path__ + "static/media/eye.b606b67f.svg";